import type { ApiFlow } from '../types'

export const commonJwtValidateFlow: ApiFlow = {
  id: 'common.jwt-validate',
  appTypes: ['spa', 'web', 'native'],
  title: 'Validate JWT (resource server)',
  summary: 'Fetch JWKS from the issuer and verify access_token or id_token signatures on your API.',
  steps: [
    {
      id: 'jwks',
      title: 'Fetch JWKS',
      when: 'API receives Authorization: Bearer <token>',
      method: 'GET',
      path: '/.well-known/jwks.json',
      responseVariants: [
        {
          label: 'success',
          status: 200,
          body: { keys: [{ kty: 'RSA', kid: '...', use: 'sig' }] },
          nextStepId: 'verify',
        },
      ],
    },
    {
      id: 'verify',
      title: 'Verify token',
      when: 'JWKS cached or kid resolved',
      method: 'GET',
      path: '<your-api-route>',
      headers: { Authorization: 'Bearer <access_token>' },
      responseVariants: [
        {
          label: 'valid',
          status: 200,
          body: { note: 'Claims: sub, iss={{ISSUER}}, aud={{CLIENT_ID}}, exp' },
        },
        {
          label: 'invalid',
          status: 401,
          body: { error: 'invalid_token' },
        },
      ],
    },
  ],
}
